import { __assign, __spreadArrays } from "tslib";
import { map } from '@antv/util';
export function getOriginKey(key) {
    return "_ORIGIN_" + key + "_";
}
export function processEmpty(data, key, transformData) {
    var originalData = __spreadArrays(data);
    return map(originalData, function (d) {
        var _a;
        var originalKey = getOriginKey(key);
        var originalValue = d[key];
        return __assign(__assign({}, d), (_a = {}, _a[key] = transformData ? transformData(originalValue) : 1, _a[originalKey] = originalValue, _a));
    });
}
//# sourceMappingURL=utils.js.map